export enum FloorPlanItemType {
  table = 1,
  object = 2,
  section = 3,
}
